function NoRatingsMessage() {
  return <p className='no-ratings-msg'>No ratings to show</p>;
}

export default NoRatingsMessage;
